/**
 * Mã đăng nhập "dễ đoán" (soát bảo mật 10/2026, B1): chủ tiệm tự đặt 6 số khi mở tiệm (ADR-087) thì kẻ gian đoán
 * 123456 / 000000 / 520131 trước. Hàm THUẦN, không `node:*` — chạy được cả ở máy chủ (`lyDoMaKhongHopLe`) lẫn ở
 * web quầy (báo sớm ở form mở tiệm), một nguồn duy nhất cho hai nơi.
 *
 * Chỉ áp cho mã TOÀN CHỮ SỐ dài 6–12 ký tự (mã chữ / cụm từ dài vẫn dùng được như trước):
 *   - các số giống nhau (000000, 888888);
 *   - dãy tăng / giảm liên tiếp, vòng qua 9→0 (123456, 567890, 987654, 098765);
 *   - lặp nhóm 1, 2, 3 số (121212, 696969, 123123, 100100);
 *   - cặp đôi (112233, 998877);
 *   - và danh sách các mã 6 số hay bị đoán nhất (thói quen gõ, ngày lễ, "520131" = "anh yêu em" tiếng Trung…).
 */

/** Câu báo cho người dùng: ngắn, không thuật ngữ. */
export const CAU_MA_DE_DOAN =
  'Mã này dễ đoán quá. Hãy chọn 6 số khó đoán hơn, đừng dùng số lặp hoặc dãy 123456.'

/** Mã 6 số thông dụng không rơi vào các quy tắc dạng ở dưới. */
const MA_PHO_BIEN = new Set([
  // Tình cảm / may mắn kiểu Trung – Việt
  '520131',
  '201314',
  '521314',
  '131420',
  '520520',
  '666888',
  '888666',
  '668899',
  '886688',
  '888999',
  '999888',
  '666999',
  '999666',
  '555666',
  '666777',
  '777888',
  '168168',
  '518518',
  '518888',
  '999000',
  // Hình dạng trên bàn phím số / dãy gõ quen tay
  '159753',
  '357951',
  '753951',
  '951753',
  '147258',
  '258369',
  '369258',
  '741852',
  '852963',
  '963852',
  '321654',
  '654123',
  '456123',
  '123654',
  '123789',
  '789456',
  '789123',
  '135790',
  '135246',
  '246810',
  '135798',
  '159357',
  '147852',
  '123321',
  '456654',
  '789987',
  '112358',
  // Số tròn / đếm
  '102030',
  '010203',
  '010101',
  '000123',
  '123000',
  '100000',
  '200000',
  '300000',
  '500000',
  '600000',
  '800000',
  '900000',
  '001122',
  '121314',
  '131313',
  '112211',
  '147147',
  '258258',
  '369369',
  // Năm sinh / ngày thường gặp
  '199000',
  '200000',
  '190190',
  '010190',
  '010180',
  '010170',
  '010100',
  '020202',
  '030303',
])

function laDayLienTiep(ma: string, buoc: 1 | 9): boolean {
  for (let i = 1; i < ma.length; i++) {
    const truoc = ma.charCodeAt(i - 1) - 48
    const sau = ma.charCodeAt(i) - 48
    if (sau !== (truoc + buoc) % 10) return false
  }
  return true
}

function laLapNhom(ma: string, dai: number): boolean {
  if (ma.length % dai !== 0 || ma.length === dai) return false
  const nhom = ma.slice(0, dai)
  return nhom.repeat(ma.length / dai) === ma
}

function laCapDoi(ma: string): boolean {
  if (ma.length % 2 !== 0) return false
  for (let i = 0; i < ma.length; i += 2) if (ma[i] !== ma[i + 1]) return false
  return true
}

/** `true` nếu mã (toàn chữ số, dài 6–12) thuộc nhóm dễ đoán. Mã có chữ / quá dài / quá ngắn → `false` (luật khác lo). */
export function laMaDeDoan(ma: string): boolean {
  if (!/^\d{6,12}$/.test(ma)) return false
  if (laLapNhom(ma, 1)) return true
  if (laDayLienTiep(ma, 1) || laDayLienTiep(ma, 9)) return true
  if (laLapNhom(ma, 2) || laLapNhom(ma, 3)) return true
  if (laCapDoi(ma)) return true
  return ma.length === 6 && MA_PHO_BIEN.has(ma)
}
